import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
  SubMenu,
} from "react-pro-sidebar";
import Icon from "@mdi/react";
import {
  mdiArrowLeft,
  mdiLogout,
  mdiCircleMedium,
  mdiViewDashboardOutline,
} from "@mdi/js";
import LOGO from "../../assets/images/logo.png";
import PROFILE from "../../assets/images/lisa.jpg";
import { useSelector, useDispatch } from "react-redux";
import { getFileHostUrl } from "../../helpers/functions";

interface Props {
  toggled: boolean;
  handleToggleSidebar: (toggled: boolean) => void;
}

const SettingSideBar: React.FC<Props> = ({ toggled, handleToggleSidebar }) => {
  const location = useLocation();
  const { user, isFetchedUser } = useSelector((state: any) => state);
  const [currentPath, setCurrentPath] = useState<string>("");
  const getPictrue = (pic: any) => {
    console.log("pic", pic);
    const picture = getFileHostUrl(pic);
    // console.log("picture", picture);
    // setPicture(picture);
    return picture;
  };
  const settingMenuItems = [
    {
      name: "PERSONNEL",
      subMenu: [
        {
          name: "USERS GROUPS",
          to: "/setting/usersgroups",
          icon: mdiCircleMedium,
        },
        {
          name: "PERSONNEL",
          to: "/setting/personnel",
          icon: mdiCircleMedium,
        },
      ],
    },

    {
      name: "PRODUCT & SERVICE",
      subMenu: [
        {
          name: "CATEGORY",
          to: "/setting/service/category",
          icon: mdiCircleMedium,
        },

        {
          name: "TREATMENT",
          to: "/setting/service/treatment",
          icon: mdiCircleMedium,
        },
        {
          name: "PROMOTION",
          to: "/setting/service/promotion",
          icon: mdiCircleMedium,
        },
        {
          name: "GIFT VOUCHER",
          to: "/setting/service/giftvoucher",
          icon: mdiCircleMedium,
        },
        {
          name: "BARTHER (VAT)",
          to: "/setting/service/barthervat",
          icon: mdiCircleMedium,
        },
      ],
    },
    {
      name: "INVENTORY ",
      subMenu: [
        {
          name: "INVENTORY SETTING",
          subMenu: [
            {
              name: "Inventory Category",
              to: "/setting/inventory/category",
              icon: mdiCircleMedium,
            },
            {
              name: "Inventory Location",
              to: "/setting/inventory/location",
              icon: mdiCircleMedium,
            },
            {
              name: "SUPPLIER",
              to: "/setting/inventory/supplier",
              icon: mdiCircleMedium,
            },
          ],
        },
        {
          name: "INVENTORY MANAGEMENT",
          to: "/setting/inventory/management",
          icon: mdiCircleMedium,
        },
        {
          name: "PURCHASE & RECEIVE",
          subMenu: [
            {
              name: "PR Order",
              to: "/setting/inventory/pr",
              icon: mdiCircleMedium,
            },
            {
              name: "PO Order",
              to: "/setting/inventory/po",
              icon: mdiCircleMedium,
            },
            {
              name: "Receive PO",
              to: "/setting/inventory/receivePo",
              icon: mdiCircleMedium,
            },
            {
              name: "Receive NO PO",
              to: "/setting/inventory/receiveNoPo",
              icon: mdiCircleMedium,
            },
            
          ]
        },
        {
          name: "REQUEST & REPLY ",
          subMenu: [
            {
              name: "Request",
              to: "/setting/inventory/request",
              icon: mdiCircleMedium,
            },
            {
              name: "Reply",
              to: "/setting/inventory/reply",
              icon: mdiCircleMedium,
            } 
          ]
          
        },
      ],
    },
    {
      name: "JOB",
      subMenu: [
        {
          name: "JOB TITLE",
          to: "/setting/job/title",
          icon: mdiCircleMedium,
        },
        // {
        //   name: "JOB GROUP",
        //   to: "/setting/job/group",
        //   icon: mdiCircleMedium,
        // },
        // {
        //   name: "JOB PERMISSION",
        //   to: "/setting/job/permission",
        //   icon: mdiCircleMedium,
        // },
      ],
    },
    {
      name: "AGENCY",
      subMenu: [
        {
          name: "AGENCY TYPE",
          to: "/setting/agency/type",
          icon: mdiCircleMedium,
        },
        {
          name: "AGENCY LIST",
          to: "/setting/agency/list",
          icon: mdiCircleMedium,
        },
      ],
    },
    {
      name: "STOCK",
      subMenu: [
        {
          name: "STOCK CATEGORY",
          to: "/setting/stock/category",
          icon: mdiCircleMedium,
        },
        {
          name: "CREATE STOCK",
          to: "/setting/stock/createStock",
          icon: mdiCircleMedium,
        },
        {
          name: "ADD STOCK",
          to: "/setting/stock/addStock",
          icon: mdiCircleMedium,
        },
        {
          name: "REQUEST STOCK",
          to: "/setting/stock/requestStock",
          icon: mdiCircleMedium,
        },
      ],
    },
  ];
  const settingOther = [
    {
      name: "OTHER SETTINGS",
      subMenu: [
        {
          name: "Unit",
          to: "/setting/other/unit",
          icon: mdiCircleMedium,
        },
      ],
    }
  ];
  const isActive = (linkTo: string) => {
    // menuItem.to === currentPath

    //  abcdefzzz              de
    // /usedcourse/SO-TestB   /usedcourse
    if (currentPath.startsWith(linkTo)) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    let path = location.pathname;
    // console.log("path =>", path);

    if (path.endsWith("/")) {
      path = path.slice(0, path.length - 1);
    }

    // console.log("path after =>", path);

    setCurrentPath(path);
  }, [location.pathname]);

  const profileUrl =
    process.env.NODE_ENV !== "development"
      ? getPictrue(user?.photoURL)
      : "/user.png";

  return (
    <ProSidebar
      toggled={toggled}
      breakPoint="xl"
      onToggle={handleToggleSidebar}
    >
      <SidebarHeader>
        <div className="logo">
          <img src={LOGO} alt="Dermaster" />
        </div>
      </SidebarHeader>

      <SidebarContent>
        <div className="sidebar-profile1">
          <div className="img-profile">
            <img src={profileUrl} />
          </div>
          <div className="info">
            <div className="info-name">{`${user.displayName}`}</div>
            <div className="info-email">{`${user.email}`}</div>
          </div>
        </div>
        <Menu popperArrow>
          <MenuItem
            className={`menu-title ${
              isActive("/setting/dashboard") ? "active" : ""
            }`}
          >
            DASHBOARD & REPORT
            <Link to="/setting/dashboard" />
          </MenuItem>
          <MenuItem
            className={`menu-title ${
              isActive("/setting/systemlog") ? "active" : ""
            }`}
          >
            SYSTEM LOG
            <Link to="/setting/systemlog" />
          </MenuItem>
          <MenuItem
            className={`menu-title ${
              isActive("/setting/viplist") ? "active" : ""
            }`}
          >
            VIP LIST
            <Link to="/setting/viplist" />
          </MenuItem>
          {settingMenuItems.map((menuItem, index) => (
            <SubMenu
              className="menu-title"
              title={menuItem.name}
              key={index}
              defaultOpen
            >
              {menuItem.subMenu.map((subMenuItem: any, index2: number) => (
                <div key={index2}>
                  {subMenuItem.subMenu ? (
                    <SubMenu
                      className="menu-title"
                      title={subMenuItem.name}
                      key={index2}
                      defaultOpen
                    >
                      {subMenuItem.subMenu.map(
                        (subMenuItems: any, index3: number) => (
                          <MenuItem
                            className={`menu-title ${
                              isActive(subMenuItems.to) ? "active" : ""
                            }`}
                            icon={<Icon path={mdiCircleMedium} size="20" />}
                            key={index3}
                          >
                            {subMenuItems.name}
                            <Link to={subMenuItems.to || ""} />
                          </MenuItem>
                        )
                      )}
                    </SubMenu>
                  ) : (
                    <MenuItem
                      className={`menu-title ${
                        isActive(subMenuItem.to) ? "active" : ""
                      }`}
                      icon={<Icon path={mdiCircleMedium} size="20" />}
                      key={index}
                    >
                      {subMenuItem.name}
                      <Link to={subMenuItem.to || ""} />
                    </MenuItem>
                  )}
                </div>
              ))}
            </SubMenu>
          ))}
          <MenuItem
            className={`menu-title ${
              isActive("/setting/branches") ? "active" : ""
            }`}
          >
            BRANCHES
            <Link to="/setting/branches" />
          </MenuItem>
          <MenuItem
            className={`menu-title ${
              isActive("/setting/medicalequipment") ? "active" : ""
            }`}
          >
            <span style={{ textTransform: "uppercase" }}>
              Medical Equipment
            </span>
            <Link to="/setting/medicalequipment" />
          </MenuItem>

          <MenuItem
            className={`menu-title ${
              isActive("/setting/payment") ? "active" : ""
            }`}
          >
            <span style={{ textTransform: "uppercase" }}>PAYMENT& PAY IN</span>
            <Link to="/setting/payment" />
          </MenuItem>

          {settingOther.map((menuItem, index) => (
            <SubMenu
              className="menu-title"
              title={menuItem.name}
              key={index}
              defaultOpen
            >
              {menuItem.subMenu.map((subMenuItem: any, index2: number) => (
                <div key={index2}>
                  {subMenuItem.subMenu ? (
                    <SubMenu
                      className="menu-title"
                      title={subMenuItem.name}
                      key={index2}
                      defaultOpen
                    >
                      {subMenuItem.subMenu.map(
                        (subMenuItems: any, index3: number) => (
                          <MenuItem
                            className={`menu-title ${
                              isActive(subMenuItems.to) ? "active" : ""
                            }`}
                            icon={<Icon path={mdiCircleMedium} size="20" />}
                            key={index3}
                          >
                            {subMenuItems.name}
                            <Link to={subMenuItems.to || ""} />
                          </MenuItem>
                        )
                      )}
                    </SubMenu>
                  ) : (
                    <MenuItem
                      className={`menu-title ${
                        isActive(subMenuItem.to) ? "active" : ""
                      }`}
                      icon={<Icon path={mdiCircleMedium} size="20" />}
                      key={index}
                    >
                      {subMenuItem.name}
                      <Link to={subMenuItem.to || ""} />
                    </MenuItem>
                  )}
                </div>
              ))}
            </SubMenu>
          ))}
        </Menu>
      </SidebarContent>

      <SidebarFooter>
        <Menu>
          <MenuItem
            className="menu-title"
            icon={<Icon path={mdiArrowLeft} size="20" color="#AEAEAE" />}
          >
            Return To Main Menu
            <Link to="/home" />
          </MenuItem>
          <MenuItem
            className="menu-title"
            icon={<Icon path={mdiLogout} size="20" color="#AEAEAE" />}
          >
            Logout
            <Link to="/logout" />
          </MenuItem>
        </Menu>
      </SidebarFooter>
    </ProSidebar>
  );
};

export default SettingSideBar;
